export interface GetPopoverPosition {
    (left: number, right: number, breakpoint: number, width: number): number;
}

export const getLtrPopoverPosition: GetPopoverPosition = (left, right, breakpoint, width) =>
    right > breakpoint ? right - width : left;

export const getRtlPopoverPosition: GetPopoverPosition = (left, right, breakpoint, width) =>
    left > breakpoint ? right - width : left;
